/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Settings_Files_Active_Filters_NameInputs */

const es_settings_files_active_filters_name = /** @type {(inputs: Settings_Files_Active_Filters_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nombre: "${i?.name}"`)
};

const en_settings_files_active_filters_name = /** @type {(inputs: Settings_Files_Active_Filters_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Name: "${i?.name}"`)
};

/**
* | output |
* | --- |
* | "Name: \"{name}\"" |
*
* @param {Settings_Files_Active_Filters_NameInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_active_filters_name = /** @type {((inputs: Settings_Files_Active_Filters_NameInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Active_Filters_NameInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_active_filters_name(inputs)
	return en_settings_files_active_filters_name(inputs)
});
export { settings_files_active_filters_name as "settings.files.active_filters.name" }